module.exports = __webpack_public_path__ + "static/img/12areaA_15.872d940.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/12areaA_15.png
// module id = 1009
// module chunks = 1